import io from 'socket.io-client';
import { setIsUserOnline, setLauncherGuideVisibility } from './utils';

let checkInterval = null;
let activeGameSockets = null;
let activeApiSocket = null;
let shouldStayConnected = false;

export function isGuiRoute(pathname = '') {
  return /\/i\/gui(\/|$)/.test(pathname);
}

function scheduleReconnect(socket) {
  setTimeout(() => {
    if (shouldStayConnected && socket && !socket.connected) {
      socket.connect();
    }
  }, 2000);
}

function teardownSocket(socket) {
  if (!socket || typeof socket.disconnect !== 'function') {
    return;
  }

  socket.off();
  socket.io.opts.reconnection = false;
  socket.disconnect();
}

export function socketSetCurrent(socket) {
  window.socket = socket;
  return {
    type: 'SOCKET_SET_CURRENT',
    current: socket,
  };
}

let apiReconnectAttempts = 0;

export function connectApiSocket({ name, _id, id, accessToken }) {
  const sessionId = _id || id || accessToken;
  if (!name || !sessionId) {
    return () => {};
  }

  return dispatch => {
    shouldStayConnected = true;

    if (activeApiSocket) {
      teardownSocket(activeApiSocket);
    }

    const isLocalDev = process.env.NODE_ENV === 'development';
    const socketQuery = `auth=${encodeURIComponent(name)}&name=${encodeURIComponent(
      name
    )}&session=${encodeURIComponent(String(sessionId))}`;
    const apiSocket = io.connect(isLocalDev ? 'http://127.0.0.1:3000' : undefined, {
      path: '/socket.io',
      query: socketQuery,
      transports: ['websocket'],
      upgrade: false,
      forceNew: true,
      reconnection: false,
    });

    activeApiSocket = apiSocket;

    apiSocket.on('connect', () => {
      apiReconnectAttempts = 0;
    });

    apiSocket.on('connect_error', () => {
      if (apiReconnectAttempts < 3) {
        apiReconnectAttempts += 1;
        scheduleReconnect(apiSocket);
      }
    });

    dispatch({
      type: 'API_SOCKET_CONNECT',
      api: apiSocket,
    });
  };
}

export function connectSockets({ name, _id, id, accessToken }) {
  const sessionId = _id || id || accessToken;
  if (!name || !sessionId) {
    console.warn('connectSockets: missing name or session id', { name, _id, id });
    return () => {};
  }

  return dispatch => {
    shouldStayConnected = true;

    if (activeGameSockets) {
      activeGameSockets.forEach(teardownSocket);
    }

    const isLocalDev = process.env.NODE_ENV === 'development';
    if (isLocalDev) {
      console.log('Socket session:', { name, sessionId: String(sessionId) });
    }
    const socketQuery = `auth=${encodeURIComponent(name)}&name=${encodeURIComponent(
      name
    )}&session=${encodeURIComponent(String(sessionId))}&key=${encodeURIComponent(
      String(sessionId)
    )}`;
    const socket = io.connect(isLocalDev ? 'http://127.0.0.1:4711' : undefined, {
      path: isLocalDev ? '/socket.io' : '/ws',
      query: socketQuery,
      transports: ['websocket'],
      upgrade: false,
      forceNew: true,
      reconnection: false,
    });

    activeGameSockets = [socket];

    socket.on('connect', () => {
      window.socket = socket;
      dispatch(socketSetCurrent(socket));
      dispatch(setLauncherGuideVisibility(false));
    });

    socket.on('connect_error', () => {
      scheduleReconnect(socket);
    });
    socket.on('disconnect', () => {
      if (shouldStayConnected) {
        scheduleReconnect(socket);
      }
    });
    window.socket = socket;

    dispatch({
      type: 'SOCKET_CONNECT',
      sockets: [socket],
    });

    const setIsOnline = value => {
      dispatch(setIsUserOnline(value));
      if (value) {
        dispatch(socketSetCurrent(socket));
        dispatch(setLauncherGuideVisibility(false));
      }
    };

    socket.on('playerJoined', () => setIsOnline(true));
    clearInterval(checkInterval);
    checkInterval = setInterval(() => {
      if (!shouldStayConnected || !socket.connected) {
        return;
      }

      socket.emit('isOnline', name, value => {
        setIsOnline(value);
      });
    }, 1500);
  };
}

export function disconnectSockets(sockets, apiSocket) {
  shouldStayConnected = false;

  const gameSockets = sockets || activeGameSockets;
  const api = apiSocket || activeApiSocket;

  if (gameSockets) {
    gameSockets.forEach(teardownSocket);
  }

  if (api) {
    teardownSocket(api);
  }

  activeGameSockets = null;
  activeApiSocket = null;
  window.socket = null;
  clearInterval(checkInterval);
  checkInterval = null;

  return {
    type: 'SOCKET_DISCONNECT',
  };
}
